import { render, staticRenderFns } from "./TipoSelection.vue?vue&type=template&id=390f0e91&"
import script from "./TipoSelection.vue?vue&type=script&lang=js&"
export * from "./TipoSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports